// Concrete instances of each section type model
const sectionTypeModels = {
    standard: {
        canonicalName: 'standard',
        rounds: null,
        executionStrategy: 'sequential',
        inputs: [],
        rules: { minSteps: 1, maxSteps: Number.POSITIVE_INFINITY },
        supportedRepetitionModesForItsStepPlans: (mode) => mode === 'explicit' || mode === 'template',
        getSetCount: ({ stepPlan, setPlans }) => stepPlan.repetitionMode === 'template' ? stepPlan.templateSets : setPlans.length,
        getDefaultInputValues: () => ({ rounds: null, durationSeconds: null, intervalSeconds: null }),
    },
    superset: {
        canonicalName: 'superset',
        rounds: 1, // Default value, will be user-configurable
        executionStrategy: 'interleaved',
        inputs: [{ name: 'rounds', label: 'sets' }],
        rules: { minSteps: 2, maxSteps: Number.POSITIVE_INFINITY },
        supportedRepetitionModesForItsStepPlans: (mode) => mode === 'explicit' || mode === 'template',
        getSetCount: ({ sectionPlan }) => sectionPlan.rounds,
        getDefaultInputValues: () => ({ rounds: null, durationSeconds: null, intervalSeconds: null }),
    },
    circuit: {
        canonicalName: 'circuit',
        rounds: 1, // Default value, will be user-configurable
        executionStrategy: 'interleaved',
        inputs: [{ name: 'rounds', label: 'rounds' }],
        rules: { minSteps: 2, maxSteps: Number.POSITIVE_INFINITY },
        supportedRepetitionModesForItsStepPlans: (mode) => mode === 'explicit' || mode === 'template',
        getSetCount: ({ sectionPlan }) => sectionPlan.rounds,
        getDefaultInputValues: () => ({ rounds: null, durationSeconds: null, intervalSeconds: null }),
    },
    amrap: {
        canonicalName: 'amrap',
        rounds: null,
        executionStrategy: 'interleaved',
        inputs: [{ name: 'durationSeconds', label: 'time cap' }],
        rules: { minSteps: 1, maxSteps: Number.POSITIVE_INFINITY },
        supportedRepetitionModesForItsStepPlans: (mode) => mode === 'template',
        getSetCount: ({ sectionPlan }) => sectionPlan.rounds,
        getDefaultInputValues: () => ({ rounds: null, durationSeconds: null, intervalSeconds: null }),
    },
    emom: {
        canonicalName: 'emom',
        rounds: null,
        executionStrategy: 'interleaved',
        inputs: [
            { name: 'intervalSeconds', label: 'every' },
            { name: 'durationSeconds', label: 'duration' },
        ],
        rules: { minSteps: 1, maxSteps: Number.POSITIVE_INFINITY },
        supportedRepetitionModesForItsStepPlans: (mode) => mode === 'template',
        getSetCount: ({ sectionPlan }) => sectionPlan.rounds,
        getDefaultInputValues: () => ({ rounds: null, durationSeconds: null, intervalSeconds: null }),
    },
};
export { sectionTypeModels };
//# sourceMappingURL=section-type.types.js.map